var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import './../../assets/scss/form_styles.scss';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { FormControl } from '@mui/material';
import moment from 'moment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { INPUT_TYPOGRAPHY_SX } from './inputTypography';
const MUIDatePicker = (_a) => {
    var { labelText, label, selectedDate, value, dateChangeHandler, onChange, errorMessage, error_message, isMandatory, isMandatoryField, disabled, minDate, maxDate, disableFuture, maskValue, isOcrPrefilled, name, fullWidth = true, placeholder, showClearIcon } = _a, rest = __rest(_a, ["labelText", "label", "selectedDate", "value", "dateChangeHandler", "onChange", "errorMessage", "error_message", "isMandatory", "isMandatoryField", "disabled", "minDate", "maxDate", "disableFuture", "maskValue", "isOcrPrefilled", "name", "fullWidth", "placeholder", "showClearIcon"]);
    const resolvedLabel = label || labelText || '';
    const resolvedDate = value !== undefined ? value : selectedDate;
    const resolvedError = errorMessage || error_message;
    const resolvedChange = onChange || dateChangeHandler;
    const resolvedMandatory = isMandatoryField || isMandatory;
    const labelNode = isOcrPrefilled ? (React.createElement("span", { style: { display: 'inline-flex', alignItems: 'center', gap: 3 } },
        React.createElement(CheckCircleIcon, { style: { fontSize: 15, color: '#2E7D32' } }),
        resolvedLabel,
        resolvedMandatory && React.createElement("span", { style: { color: '#F00214' } }, " *"))) : resolvedMandatory && resolvedLabel ? (React.createElement(React.Fragment, null,
        resolvedLabel,
        React.createElement("span", { style: { color: '#F00214' } }, " *"))) : (resolvedLabel);
    return (React.createElement(FormControl, { fullWidth: fullWidth, error: Boolean(resolvedError), style: {} },
        React.createElement(DesktopDatePicker, Object.assign({ label: labelNode, value: resolvedDate ? moment(resolvedDate) : null, onChange: (newVal) => {
                resolvedChange === null || resolvedChange === void 0 ? void 0 : resolvedChange(newVal ? newVal.format('YYYY-MM-DD') : null);
            }, disabled: disabled, disableFuture: disableFuture, minDate: minDate ? moment(minDate) : undefined, maxDate: maxDate ? moment(maxDate) : undefined, sx: { backgroundColor: '#fff', borderRadius: '4px' }, slotProps: {
                popper: {
                    sx: {
                        '& .MuiDateCalendar-root': {
                            width: 260,
                            height: 280,
                        },
                        '& .MuiPickersCalendarHeader-root': {
                            minHeight: 32,
                            paddingLeft: '8px',
                            paddingRight: '4px',
                        },
                        '& .MuiPickersCalendarHeader-label': {
                            fontSize: '13px',
                        },
                        '& .MuiPickersArrowSwitcher-button': {
                            padding: '4px',
                        },
                        '& .MuiDayCalendar-weekDayLabel': {
                            width: 30,
                            height: 30,
                            fontSize: '11px',
                        },
                        '& .MuiPickersDay-root': {
                            width: 30,
                            height: 30,
                            fontSize: '12px',
                        },
                        '& .MuiPickersYear-yearButton, & .MuiPickersMonth-monthButton': {
                            fontSize: '12px',
                        },
                    },
                },
                textField: {
                    size: 'small',
                    variant: 'outlined',
                    fullWidth: true,
                    name,
                    placeholder,
                    error: Boolean(resolvedError),
                    helperText: resolvedError,
                    InputLabelProps: {
                        shrink: placeholder ? true : undefined,
                        sx: {
                            '&:not(.MuiInputLabel-shrink)': {
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                maxWidth: 'calc(100% - 48px)',
                            },
                            '&.MuiInputLabel-shrink': {},
                        },
                    },
                    sx: Object.assign(Object.assign({}, INPUT_TYPOGRAPHY_SX), { '& .MuiInputBase-input': Object.assign({}, INPUT_TYPOGRAPHY_SX['& .MuiInputBase-input']), '& .MuiInputBase-root.Mui-disabled': {
                            '& .MuiOutlinedInput-notchedOutline': {
                                background: 'rgb(0 0 0 / 5%)',
                            },
                        } }),
                },
                field: {
                    clearable: !!showClearIcon,
                    onClear: () => resolvedChange === null || resolvedChange === void 0 ? void 0 : resolvedChange(null),
                },
            } }, rest))));
};
export default MUIDatePicker;
